/* eslint-disable max-len */
/* eslint-disable max-lines */
import React, {useMemo} from 'react';
import {useTable, usePagination, useFilters, useRowSelect} from 'react-table';
import {Table, Button, Dropdown, Input, Grid, Loader} from 'semantic-ui-react';
import {Filter, DefaultShipmentColumnFilter} from '../internalCommons/TableFilters';
import {invoicesPageSizesCustomOrders} from '../../../common/constants/lists';
import {Actions} from '../../../common/actions';
import {connect} from 'react-redux';
import {cloneDeep} from 'lodash';
import {destinyValues} from '../../constants';

const handleInputText = (row, data, handleChange, value, keyValue) => {
  const newData = [...data];
  Object.assign(newData[row.index], {[keyValue]: value});
  handleChange({...newData[row.index]});
};

const sumShipments = (row) => {
  let sum = 0;
  for (const prop in row.original) {
    if (prop.includes('shipmentItem')) {
      sum += parseInt(row.original[prop], 10) || 0;
    }
  }
  return sum;
};

const validateMax = (row, value, prop) => {
  const currentValue = sumShipments(row) - row.original[prop] + (parseInt(value, 10) || 0);
  const minValue = row.original.saleLines;
  const maxValue = row.original.amount < row.original.cifNotZero ? row.original.amount : row.original.cifNotZero;
  if (
    currentValue <= maxValue &&
    currentValue >= minValue &&
    !isNaN(value)) {
    return true;
  }
  return false;
};

const shipmentHeadersWithProps = (
  {
    orders,
    dataCloned,
    showShipmentHeader,
    showShipmentHeaderShip,
  },
  {handleChange,
    setShowShipmentHeader,
    fetchGetShipmentHeader,
    setUpdateShipmentHeader,
    setShowShipmentHeaderShip,
  }) => {
  const firstOrder = orders[0];
  const headers = [];
  for (const prop in firstOrder) {
    if (prop.includes('shipmentItem')) {
      if (prop.split('shipmentItem')[1] < parseInt(firstOrder.nShips.value, 10) + 1) {
        headers.push(
          {
            'Header': () => <span
              className="header-title pointer text-primary"
              onClick={() => {
                setShowShipmentHeader(true);
                setShowShipmentHeaderShip(firstOrder[prop].number);
                setUpdateShipmentHeader('UPDATE');
                fetchGetShipmentHeader(
                  firstOrder.order.value,
                  firstOrder[prop].number,
                );
              }}
              key={prop}
            >
              {firstOrder[prop].text}
            </span>,
            'accessor': prop,
            'width': 150,
            'Cell': ({row}) => {
              return (
                <>
                  {showShipmentHeader && showShipmentHeaderShip === firstOrder[prop].number ?
                    <Input
                      value={row.original[prop]}
                      onChange={(e, {value}) => validateMax(row, value, prop) && handleInputText(row, dataCloned, handleChange, value, prop)}
                      className="width-temp-order-small"
                      type='Number'
                      min='0'
                      max={`${row.original.amount}`}
                    /> :
                    <div>{row.original[prop]}</div>
                  }
                </>
              );
            },
            'className': 'cell-custom width-order-small',
          }
        );
      } else {
        headers.push({
          'Header': () => <span
            className="header-title"
            key={prop}
          >
            {firstOrder[prop].text}
          </span>,
          'accessor': prop,
          'width': 150,
          'Cell': ({row}) => {
            return (
              <>
                {showShipmentHeader && showShipmentHeaderShip === firstOrder[prop].number ?
                  <Input
                    value={row.original[prop] || ''}
                    onChange={(e, {value}) => validateMax(row, value, prop) && handleInputText(row, dataCloned, handleChange, value, prop)}
                    className='width-temp-order-small'
                    type='Number'
                    min='0'
                    max={`${row.original.amount}`}
                  /> :
                  <div>{row.original[prop]}</div>
                }
              </>
            );
          },
          'className': 'cell-custom width-order-small',
        });
      }
    }
  }
  return headers;
};

const tableHeaderWithProps = () => {
  return [
    {
      'Header': () => <span className="header-title">ORDEN NO.</span>,
      'accessor': 'item',
      'width': 150,
      'Cell': ({row}) => {
        return (
          <span>{row.original.item.split('-')[0]}</span>
        );
      },
      'className': 'cell-custom width-order-medium',
    },
    {
      'Header': () => <span className="header-title">DESTINO</span>,
      'accessor': 'destiny',
      'width': 150,
      'Cell': ({row}) => {
        return (
          <span>{destinyValues.find((value) => value.key === row.original.destiny).text || ''}</span>
        );
      },
      'className': 'cell-custom width-order-medium',
    },
    {
      'Header': () => <span className="header-title">AÑO MODELO</span>,
      'accessor': 'yearModel',
      'width': 250,
      'className': 'width-order-small cell-custom',
    },
    {
      'Header': () => <span className="header-title">MODELO</span>,
      'accessor': 'master',
      'width': 250,
      'Cell': ({row}) => {
        return (
          <span>{`${row.original.suffix}/${row.original.master}`}</span>
        );
      },
      'className': 'cell-custom width-order-big',
    },
    {
      'Header': () => <span className="header-title">DESCRIPCIÓN</span>,
      'accessor': 'model',
      'width': 250,
      'className': 'width-order-big cell-custom',
    },
    {
      'Header': () => <span className="header-title">COLOR EXTERNO</span>,
      'accessor': 'externalColor',
      'width': 150,
      'className': 'cell-custom width-order-medium',
    },
    {
      'Header': () => <span className="header-title">CANTIDAD</span>,
      'accessor': 'amount',
      'width': 150,
      'className': 'cell-custom width-order-medium',
    },
  ];
};

const tableHeaderPendings = () => {
  return [
    {
      'Header': () => <span className="header-title">PENDIENTE</span>,
      'accessor': 'pending',
      'width': 150,
      'Cell': ({row}) => {
        return (
          <div
            className={row.original.amount - sumShipments(row) > 0 ? 'pending-alert' : 'pending-normal'}>
            {row.original.amount - sumShipments(row)}
          </div>
        );
      },
    },

  ];
};

const tableHeaders = (
  {
    orders,
    dataCloned,
    showShipmentHeader,
    showShipmentHeaderShip,
  },
  {handleChange,
    setShowShipmentHeader,
    fetchGetShipmentHeader,
    setUpdateShipmentHeader,
    setShowShipmentHeaderShip,
  }) => {
  return [
    ...tableHeaderWithProps(),
    ...shipmentHeadersWithProps(
      {
        orders,
        dataCloned,
        showShipmentHeader,
        showShipmentHeaderShip,
      },
      {handleChange,
        setShowShipmentHeader,
        fetchGetShipmentHeader,
        setUpdateShipmentHeader,
        setShowShipmentHeaderShip,
      }
    ),
    ...tableHeaderPendings()];
};

const TablePaginator = ({
  page,
  canPreviousPage,
  pageIndex,
  pageOptions,
  pageSize,
  canNextPage,
  nextPage,
  gotoPage,
  previousPage,
  setPageSize,
}) => {
  if (page.length) {
    return (
      <Grid className="pagination">
        <Grid.Row>
          <Grid.Column width={4} textAlign="left">
            <Button
              className="navigation-button"
              onClick={() => previousPage()}
              disabled={!canPreviousPage}
              content="Anterior"
            />
          </Grid.Column>
          <Grid.Column width={4} textAlign="right">
            <span>páginas </span>
            <span>
              <Input
                className="pages-input"
                type="number"
                value={pageIndex + 1}
                min="1"
                max={pageOptions.length}
                onChange={(e, {value}) => {
                  const page = value ? Number(value) - 1 : 0;
                  if (page < 1 || page > pageOptions.length) {
                    e.target.value = 1;
                  }
                  gotoPage(page);
                }}
              />
            </span>{' '}
            <span>de {pageOptions.length}</span>
          </Grid.Column>
          <Grid.Column width={4} textAlign="left">
            <Dropdown
              className="page-sizes-selection"
              selection
              upward
              compact
              value={pageSize}
              options={invoicesPageSizesCustomOrders}
              onChange={(e, {value}) => {
                setPageSize(Number(value));
              }}
            />
            <span> filas</span>
          </Grid.Column>
          <Grid.Column width={4} textAlign="right">
            <Button
              className="navigation-button"
              onClick={() => nextPage()}
              disabled={!canNextPage}
              content="Siguiente"
            />
          </Grid.Column>
        </Grid.Row>
      </Grid>
    );
  }
  return null;
};

const ShipmentsTable = ({
  loading,
  dataTable,
  dataTableFormated,
  handleChange,
  updateTable,
  setShowShipmentHeader,
  fetchGetShipmentHeader,
  setUpdateShipmentHeader,
  setShowShipmentHeaderShip,
  showShipmentHeader,
  showShipmentHeaderShip,
}) => {
  if (loading) {
    return <Loader active inline='centered' className='custom-loader' />;
  }

  const clone = cloneDeep(dataTableFormated);
  const columnsTable = tableHeaders(
    {
      'orders': dataTable,
      'dataCloned': clone,
      showShipmentHeader,
      showShipmentHeaderShip,
    },
    {
      handleChange,
      setShowShipmentHeader,
      fetchGetShipmentHeader,
      setUpdateShipmentHeader,
      setShowShipmentHeaderShip,
    },
  );
  const data = useMemo(() => clone, [updateTable, dataTable]);
  const columns = useMemo(() => columnsTable, [updateTable]);

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    page,
    canPreviousPage,
    canNextPage,
    pageOptions,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    'state': {pageIndex, pageSize},
  } = useTable(
    {
      columns,
      data,
      'defaultColumn': {'Filter': DefaultShipmentColumnFilter},
      'initialState': {'pageIndex': 0, 'pageSize': 200},
    },
    useFilters,
    usePagination,
    useRowSelect
  );

  return (
    <>
      <div className="table-wrapper shipment-table">
        <Table className="interactive" compact striped {...getTableProps()}>
          <Table.Header className='sticky z-index-10'>
            {headerGroups.map((headerGroup) => (
              <Table.Row key="headers" {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map((column, index) => (
                  <Table.HeaderCell
                    key={`title-${index}`}
                    textAlign="center"
                    className='th-semanctic-custom'
                    {...column.getHeaderProps()}
                  >
                    {column.render('Header')}
                  </Table.HeaderCell>
                ))}
              </Table.Row>
            ))}
            {headerGroups.map((headerGroup) => (
              <Table.Row key="filters" id="filters">
                {headerGroup.headers.map((column, index) => (
                  <Table.HeaderCell key={`filter-${index}`} textAlign="center">
                    <Filter column={column} />
                  </Table.HeaderCell>
                ))}
              </Table.Row>
            ))}
          </Table.Header>
          <Table.Body className='body-custom' {...getTableBodyProps()}>
            {!page.length && (
              <Table.Row>
                <Table.Cell colSpan={15} textAlign="center">
                  No hay datos disponibles
                </Table.Cell>
              </Table.Row>
            )}
            {page.length > 0 &&
              page.map((row, i) => {
                prepareRow(row);
                return (
                  <Table.Row
                    key={i}
                    className={`
                  row-custom cell-custom-inventory-models ${i % 2 === 0 ? 'table-row-odd' : 'table-row-even'}
                  `}
                  >
                    {row.cells.map((cell) => {
                      return (
                        <Table.Cell
                          textAlign="center"
                          className={cell.column.className}
                        >
                          {cell.render('Cell')}
                        </Table.Cell>
                      );
                    })}
                  </Table.Row>
                );
              })}
          </Table.Body>
        </Table>
      </div>
      <TablePaginator
        page={page}
        canPreviousPage={canPreviousPage}
        pageIndex={pageIndex}
        pageOptions={pageOptions}
        pageSize={pageSize}
        canNextPage={canNextPage}
        nextPage={nextPage}
        gotoPage={gotoPage}
        previousPage={previousPage}
        setPageSize={setPageSize}
      />
    </>
  );
};

const mapStateToProps = (state) => ({
  'loading': state.manageOrders.loadingSecondary,
  'updateTable': state.manageOrders.updateTable,
  'showShipmentHeader': state.manageOrders.showShipmentHeader,
  'showShipmentHeaderShip': state.manageOrders.showShipmentHeaderShip,
});

const {fetchGetShipmentHeader,
  fetchOrigins,
  setShowShipmentHeader,
  setShipmentHeader,
  setShowShipmentHeaderShip,
  setUpdateShipmentHeader,
} = Actions;

export default connect(mapStateToProps, {
  fetchGetShipmentHeader,
  fetchOrigins,
  setShowShipmentHeader,
  setShipmentHeader,
  setShowShipmentHeaderShip,
  setUpdateShipmentHeader,
})(ShipmentsTable);
